/**
 * SOLID Review
 * S — Strong. 17 lines: find the `#root` DOM node (throwing a clear fatal error if absent) and mount
 *     `<App>` inside `StrictMode`. A single, minimal bootstrap responsibility.
 * O — Strong. Nothing to extend; a true entry point. N/A /
 * L — N/A — no inheritance hierarchy.
 * I — Strong. No props/interface surface at all.
 * D — Strong. Depends only on `react`, `react-dom/client` and the local `App` — nothing from
 *     application/infrastructure/domain layers.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error(
    '[Meyer Live 3D] Fatal: Root DOM element with id "root" was not found. ' +
      'Ensure index.html contains <div id="root"></div>.'
  );
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
